import React from 'react';
import { FiFileText } from 'react-icons/fi'; // import document icon
import { useNavigate } from 'react-router-dom';

const Bsshome = ({token}) => {
    const navigate = useNavigate();
      const handleNavigate = () => {
    const path = token ? `/bbs-form?allow=${token}` : '/bbs-form';
    navigate(path);
  };
  return (
    <div 
  
    className="mt-10 bg-white shadow-lg rounded p-4 px-6 border-[1.5px] border-gray-100 flex flex-col justify-between">
      <div className="text-[12px] font-semibold text-left mb-6">
        BEHAVIOR BASED SAFETY (BBS) CARD
      </div>

      <div className="flex justify-center">
        <button  onClick={() => handleNavigate()} className="bg-black text-white text-sm px-6 py-1 w-full rounded flex items-center justify-center gap-2 transition">
          <FiFileText className="text-md\" />
          Fill out Form
        </button>
      </div>
         {/* <div className="mt-10 bg-white shadow-lg rounded p-4 px-6 border-[1.5px] border-gray-100 mx-6">
          <h2 className="text-[13px] font-semibold text-left ">
            UPLOAD FORM
          </h2>
          <p className='text-left text-gray-400 text-xs mb-6'>
            Upload a completed form by taking a photo or selecting an image
          </p>
          <div className="flex justify-center">
            <button className="bg-black text-white text-sm px-6 py-1 w-full rounded flex items-center justify-center gap-2 transition">
              <FiCamera className="text-md" />
              Upload Form
            </button>
          </div>
        </div> */}
    </div>
  );
};

export default Bsshome;
